export default __webpack_public_path__ + "static/sustain2-f385c014e065c71a57e5b2b528bdd120.webp";